import axios from 'axios';
import { Folder } from './folders.types';

export async function fetchFolders(): Promise<Folder[]> {
  return (await axios.get('/folders/listFolders')).data;
}

export function removeDecisionFromFolder(
  docId: string,
  folderKey: string,
): Promise<{}> {
  return axios.post('/folders/removeDecision', {
    docId,
    folderKey,
  });
}

export function renameFolder({
  folderKey,
  title,
}: {
  folderKey: string;
  title: string;
}): void {
  axios.post('/folders/renameFolder', { folderKey, title });
}

export function deleteFolder(folderKey: string): void {
  axios.post('/folders/deleteFolder', { folderKey });
}

export async function createFolder(title: string): Promise<string> {
  const {
    data: { folderKey },
  } = await axios.post('/folders/createFolder', {
    title,
  });
  return folderKey;
}

export async function fetchFoldersChronologically(): Promise<Folder[]> {
  return (
    await axios.get('/folders/listFolders', {
      params: {
        sort: 'chrono',
      },
    })
  ).data;
}

export function addDecisionToFolder({
  docId,
  folderKey,
  queryKey,
}: {
  docId: string;
  folderKey: string;
  queryKey: string;
}): Promise<{}> {
  return axios.post('/folders/addDecision', {
    docId,
    folderKey,
    queryKey,
  });
}

export async function createAndAddDecisionToFolder({
  docId,
  title,
  queryKey,
}: {
  docId: string;
  title: string;
  queryKey: string;
}): Promise<{ folderKey: string }> {
  return (
    await axios.post('/folders/createAndAddDecision', {
      docId,
      title,
      queryKey,
    })
  ).data;
}

export function addMultipleDecisionToFolder({
  docIds,
  folderKey,
  queryKey,
}: {
  docIds: string[];
  folderKey: string;
  queryKey: string | null;
}): void {
  axios.post('/folders/addDecisions', {
    docIds,
    folderKey,
    queryKey,
  });
}
